import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchHistoryDates, getDownloadUrl, clearToken } from '../api';

export default function History() {
  const { customer } = useParams();
  const navigate = useNavigate();
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistoryDates(customer)
      .then((data) => setDates(data.dates || []))
      .catch(() => setDates([]))
      .finally(() => setLoading(false));
  }, [customer]);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-gray-800 text-white px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <h1 className="text-xl font-bold">Report History — {customer}</h1>
          <div className="flex gap-2">
            <button
              onClick={() => navigate(`/dashboard/${customer}`)}
              className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded text-sm transition"
            >
              Current Report
            </button>
            <button
              onClick={() => { clearToken(); navigate('/'); }}
              className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded text-sm transition"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-6">
        {loading ? (
          <p className="text-gray-500">Loading...</p>
        ) : dates.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
            No historical reports found. Reports are archived after each daily run.
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow divide-y">
            {dates.map((d) => (
              <div key={d} className="flex items-center justify-between px-6 py-4 hover:bg-gray-50">
                <span className="text-gray-800 font-medium">
                  {new Date(d + 'T12:00:00').toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={() => navigate(`/history/${customer}/${d}`)}
                    className="bg-teal-700 text-white px-3 py-1.5 rounded text-sm hover:bg-teal-800 transition"
                  >
                    View
                  </button>
                  <a
                    href={getDownloadUrl(customer, d)}
                    className="bg-gray-200 text-gray-700 px-3 py-1.5 rounded text-sm hover:bg-gray-300 transition"
                  >
                    Download Excel
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
